module.exports = __webpack_public_path__ + "static/img/vivianliu8.b0361e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/vivianliu8.png
// module id = zolG
// module chunks = 1